export default "__VITE_ASSET__232ccdb4__"